import { render, staticRenderFns } from "./CurrentAutoInsurer.vue?vue&type=template&id=f60ecfd8&"
import script from "./CurrentAutoInsurer.vue?vue&type=script&lang=js&"
export * from "./CurrentAutoInsurer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports